const bellacloud = {
  portugues: {
    title: 'Meu BELLA CLOUD',
    subTitle: 'Aqui você pode organizar e armazenar fotos e vídeos de suas modelos favoritas.',
    descriptionWellcome: `
      <p>
      O <strong>Bella Cloud</strong> é um lugar onde você armazena as fotos e vídeos do <strong>Bella da Semana</strong> que mais gosta. Nele é possível criar álbuns privados, ou compartilhados com seus amigos e outros usuários.
      </p>
      <p>
      Você organiza da forma que achar melhor.
      </p>
      <p>
      Seus amigos e assinantes poderão classificar e comentar os seus álbuns compartilhados, criando um ranking das fotos e vídeos mais tops do site.
      </p>
      <p>
      <strong>Comece o seu agora mesmo e mostre que você entende de mulher!</strong>
      </p>`,
    commentBox: 'Últimos comentários',
    commentAllBox: 'Veja todos os comentários',
    topAlbuns: 'Top Álbuns',
    othersAlbums: 'Veja os álbuns de outros assinantes',
    seeAllTops: "Ver mais",
    notMyAlbuns: "Você ainda não possui nenhum álbum. Crie sua primeira pasta clicando em “ADICIONAR NOVO ÁLBUM” no canto superior direito.",
    by: "por",
    linkLogin: 'Faça o login e crie os seus álbuns.',
    titleWellcome: "Seja bem vindo ao Bella Cloud",
    yoursComment: 'Deixe seu comentário',
    yourNickname: 'Seu nickname é',
    notYourNickName: 'não é',
    alterNickName: 'clique aqui para alterar',
    inputComment: 'Escreva seu comentário aqui',
    button: 'Enviar',
    subscriber: 'Assinante',
    formNewsCheck: 'Receber a newsletter do Bella da Semana',
    wroteOn: 'escreveu em',
    titleTopsPage: 'Bella Cloud - Top Álbuns',
    seeMore: "Veja mais",
    titleModal: "Criar Novo Álbum",
    formResetNameAlbum: "Nome do Album",
    albumPublic: "Álbum Público",
    btnSendNewAlbum: "Salvar",
    btnClose: "Fechar",
    saveBellaCloud: 'Salvar no BellaCloud',
    addAlbum: 'Adicionar',
    newAlbum: 'Novo álbum',        
    saveAlbumInfo: 'Clique no álbum para adicionar ou remover item',
    successBellaCloudPhoto: "Item inserido com sucesso!",
    errorBellaCloudPhoto: "Falha ao inserir item!",
    topalbum: "Top Álbuns",
    photos: 'Fotos',
    video: 'Videos',
    goBackAlbuns: 'Voltar para os Álbuns',
    goFavoriteModels: 'Modelos Favoritas',
    deletePasta: 'Deletar',
    editPasta: 'Editar',
    answer: 'Responder',
    yourName: 'Seu nome',
    yourEmail: 'Seu email',
    buttonSaveOrder : 'Salvar ordenação'
  },
  ingles: {
    title: 'My BELLA CLOUD',
    subTitle: 'Here you can organize and store photos and videos of your favorite models.',
    commentAllBox: 'See all comments',
    descriptionWellcome: `
    <p>
    <strong>Bella Cloud</strong> is a place where you store the photos and videos of the <strong>Bella Club</strong> you like best.<br>It is possible to create private albums, or shared with your friends and other users.
    </p>
    <p>
      You organize as you see fit.
    </p>
    <p>
      Your friends and subscribers will be able to rate and comment on your shared albums, creating a ranking of the most top photos and videos on the site.
    </p>
    <p>
     <strong>Start yours now and show that you understand women!</strong>
    </p>`,
    commentBox: 'Latest comments',
    topAlbuns: 'Top Albums',
    othersAlbums: "See other subscribers' albums",
    seeAllTops: "See more",
    notMyAlbuns: "You don't have any albums yet. Create your first folder by clicking “ADD NEW ALBUM” in the top right corner.",
    by: "by",
    linkLogin: 'Login and create your albums.',
    titleWellcome: "Welcome to Bella Cloud",
    yoursComment: 'Leave your comment',
    yourNickname: 'Your nickname is',
    notYourNickName: 'Is not',
    alterNickName: 'Click here to change',
    inputComment: 'Write your comment here',
    button: 'Send',
    subscriber: 'Subscriber',
    formNewsCheck: 'Receive the Bella Club newsletter',
    wroteOn: 'wrote on',
    titleTopsPage: 'Bella Cloud - Top Albums',
    seeMore: "See more",
    titleModal: "Create New Album",
    formResetNameAlbum: "Name",
    albumPublic: "Public Albums",
    btnSendNewAlbum: "Save",
    btnClose: "Close",
    saveBellaCloud: 'Save to BellaCloud',
    newAlbum: 'New album',        
    saveAlbumInfo: 'Click on the album to add or remove item',
    addAlbum: 'Add',
    successBellaCloudPhoto: "Item inserted successfully!",
    errorBellaCloudPhoto: "Failed to insert item!",
    topalbum: "Top Albums",
    photos: 'Photos',
    video: 'Videos',
    goBackAlbuns: 'Back to albums',
    goFavoriteModels: 'Favorite Models',
    deletePasta: 'Delete',
    editPasta: 'Edit',
    answer: 'Answer',
    yourName: 'Your name',
    yourEmail: 'Your e-mail',
    buttonSaveOrder : 'Save ordering'    
  }
}

export default bellacloud
